<template>
  <div class="bindList">
     <div class='list' v-if="detail">
       <div class='con'><span>设备名称</span><span class="gray font16">在鸿学生终端</span></div>
       <div class='con' @click='optInput'>
           <span>设备手机号码</span>
           <p class="flex-between"><span class="gray font16">{{detail.phone}}</span><svg-icon icon-class="right"/></p>
       </div>
       <div class='con'><span>IMEI</span><span class="gray font16">{{detail.imei}}</span></div>
       <div class='con'><span>SN号</span><span class="gray font16">{{detail.sn}}</span></div>
       <div class='con' style="border:none"><span>设备状态</span><p class="gray font16">
         {{statusName[detail.lifeStatus]}}
         <template  v-if='detail.lifeStatus==3'>
             <span class='btn-primary activate' style='font-size:.16rem' @click='getActivate' v-if='detail.activateExpiration==0'>点击激活</span>
             <van-loading type="spinner" color="#1989fa" size='20' style="display:inline" v-else/>
         </template>
       </p></div>
       </div>
       <p class="gray font14" >提示：激活设备，请插入SIM卡并开机</p>
       <div class='btnFixed' v-if="channelCode!=='hnhxy'">
         <div class='red' @click="handleClick">解绑设备</div>
       </div>
    
     <div class='loading' v-if="loading"><van-loading type="spinner" color="#fff" /></div>

     <van-popup v-model="isInput" class="textPopup">
        <div class="inputCon">
                <p class="title">手机号码</p>
                <div  class="inputs flex-between">
                    <input v-model="curText" placeholder="" maxlength="11">
                </div>
                <div class='btn'>
                    <p @click="hide">取消</p>
                    <p @click="checkData">确定</p>
                </div>
        </div>
    </van-popup>
  </div>
</template>
<script>
  import {unbinding,activate,updateContactPhone} from '@/api/api.mine.js';
   import {getDeviceInfo} from '@/api/api.common.js';
  export default {
    data() {
      return {
        curRole:this.$store.state.loginUser.currentUserType,//3老师，5家长
        channelCode:this.$store.state.loginUser.channelCode,
        detail:'',
        Hei:'',
        loading:false,
        isInput:false,
        curText:''
      }
    },
    created(){ 
      this.getImei();
      let self=this;
      this.times=setInterval(function(){
                self.getImei(true);
      },3000)
      
    },  
    methods: {
      getHei(){
            let hei=this.$refs.top.offsetHeight;
            let clientHeight = document.documentElement.clientHeight;
            this.Hei=(clientHeight - hei - 48 )+'px';
      },
      getActivate(){
            activate({imei:this.detail.imei}).then(()=>{
              this.getImei();
            })
      },
      optInput(){
            this.isInput=true;
            this.curText=this.detail.phone;
       },
       //手机号验证
       checkData(){
         let str=this.pubMethod.checkPhone(this.curText);
         if(this.curText&&!str){
            this.$toast('请输入正确手机号码');
         }else{
          updateContactPhone({
              contactPhone:this.curText,
              studentId:this.loginUser.studentId
          }).then(data=>{
              this.loading=false;
              if(data.code=='00000'){
                  this.$toast('修改成功');
                  this.hide();
                  this.getImei();
              }
          })
         }
        
       },
       hide(){
        this.isInput=false;
       },
      getImei(str){
          getDeviceInfo({studentId:this.loginUser.studentId},str).then(data=>{
              if(data.result){
                  this.imei=data.result.imei;
                  this.detail=data.result ;
                  this.$store.commit("setDeviceInfo", data.result);
                  if(data.result.lifeStatus!==3){//
                    clearInterval(this.times);
                  }
              }
              
          })
      },
      handleClick(){ 
        this.$dialog.confirm({
            title:'解绑设备',
            message: '解绑设备后，将无法接收到该设备的相关数据，是否确定解除',
            confirmButtonColor:'#E84026',
            cancelButtonColor:'#0A59F7',
            confirmButtonText:'解绑'
         }).then(() => {
           this.loading=true;
           unbinding({
              imei:this.imei,
              studentId:this.loginUser.studentId
            }).then(()=>{
              this.loading=false;
              this.$router.go(-1);
            })
         });
        
      },
    },
    destroyed(){
      clearInterval(this.times)
    }
  }
</script>
<style lang="scss" >
.bindList{
  font-size:.16rem;
  padding:.12rem;
  color:rgba(0,0,0,.9);
  font-size: .17rem;
  .list{
    padding:0.05rem .12rem;
    margin-bottom: .06rem;
    background:#fff;
    border-radius: 8px;
    position:relative;
    .con{
      line-height: .48rem;
      display: flex;
      justify-content: space-between;
      align-items:center;
      border-bottom: 1px solid #eee;
     
    }
    .myIcon{
      width:.2rem;
      height: .18rem;
      margin-right: .1rem;
      vertical-align: top;
    }
  }
  .activate{
    padding:.03rem .06rem;
    margin-left:.05rem;
  }
  .red{
    color:#E84026
  }
 
}

</style>